export const instantAccessItems = [
  'Wszystkie 6 tomów, dla zawodników od 6 do 17+ lat',
  'Technika, taktyka i sesje dla każdego poziomu',
  'Gotowe ćwiczenia z instrukcją krok po kroku',
  'Rutyny fizyczne i testy oceny',
  'Wersja do druku i cyfrowa — używaj gdziekolwiek',
  'Nigdy więcej nie zabraknie Ci materiału',
]
